"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _cookies = require("@kiwicom/cookies");
const loadSimpleTokenAuth = () => {
  try {
    const cookie = (0, _cookies.load)(_cookies.Cookie.SIMPLE_TOKEN);
    const simpleTokenAuth = cookie ? JSON.parse(cookie) : null;
    return simpleTokenAuth || null;
  } catch (e) {
    (0, _cookies.remove)(_cookies.Cookie.SIMPLE_TOKEN);
    return null;
  }
};
var _default = exports.default = loadSimpleTokenAuth;